import { WasAggregateSelected, WasCurrencyUnitsSelected, WasPhysicalStockSelected } from "../../../utils/constants"
import _ from "lodash"
import { calculateCustomMaxYAxis, calculateCustomMinYAxis } from "../../../utils/mappers/analytics";
import { CHART_OPTIONS_GLOBAL,
        COMBO_CHART_ORDER_COLORS,
         CHART_ONE_ORDER_COLORS,
         CHART_TWO_ORDER_COLORS,
         ANALYTICS_COLOR_CODES } from "../../../utils/constants";
import i18n from "../../../i18n";
import { createZeroArray } from "../../../utils/dataGenerator";
import { SYMBOLS } from "../../../utils/constants";
import { toExcelNumberFormatWithoutDecimals } from "../../../utils/format";

export const ANALYTICS_CHART_OPTIONS =  {
    ...CHART_OPTIONS_GLOBAL,
    noData: {text: i18n.t("simulation.noDataChart"), 
    style: { fontSize: '18px' }},
}

export const SINGLE_SKU_CHART_OPTIONS = {
    ...ANALYTICS_CHART_OPTIONS,
    stroke: { width: 2 },
    markers: { size: .001 }, //markers solve problem of color in points of apex chart
}

export const ANALYTICS_CHART_LINE_OPTIONS = {
    ...ANALYTICS_CHART_OPTIONS,
    colors: ["#A0A1DF", "#FD808B"],
    stroke: { width: 2, curve: "smooth" },
}

const checkIfDataExist = (chartData)=>{
    return _.isEmpty(chartData) ? [] : chartData
}


export const getCurrentAnalyticsTypeChart = (analyticsChartDataFormatObject, analyticsToggleOptions)=>{
    const {analyticsChartData, analyticsByMaterialChartData} = analyticsChartDataFormatObject
    const isDefaultAnalyticsChart = analyticsToggleOptions[WasAggregateSelected]
    const isSingleSkuChartOptionOne = !analyticsToggleOptions[WasAggregateSelected]
    const isSingleSkuChartOptionTwo = !analyticsToggleOptions[WasAggregateSelected]
    if(isDefaultAnalyticsChart){
        return checkIfDataExist(analyticsChartData)
    }


    if(isSingleSkuChartOptionOne || isSingleSkuChartOptionTwo){
        return checkIfDataExist(analyticsByMaterialChartData)
    }
}

export const isCurrentChartOneOrChartTwo = (analyticsChartDataFormatObject, analyticsToggleOptions)=>{
    const currentAnalyticsChartData = getCurrentAnalyticsTypeChart(analyticsChartDataFormatObject, analyticsToggleOptions)
    if(_.isEmpty(currentAnalyticsChartData)){
        return []
    }
    if(analyticsToggleOptions[WasCurrencyUnitsSelected]){
        return currentAnalyticsChartData['chartOneData'] || currentAnalyticsChartData['chartOne']
    }
    if(!analyticsToggleOptions[WasCurrencyUnitsSelected]){
        return currentAnalyticsChartData['chartTwoData'] || currentAnalyticsChartData['chartTwo']
    }
}

const convertToMaxYAxisCalculatorFormat = (chartType) => {
    if(!_.isEmpty(chartType)){
        const newChartType = _.cloneDeep(chartType)
        Object
            .keys(newChartType)
            .forEach((key)=>{
                newChartType[key] = newChartType[key].map((arrayPoint)=>(arrayPoint[1]))
            })
    
        return newChartType
    }
}

// nfe = net flow equation
// ohs = on hand stock
// chart type cloud be chart one or chart two
const fullFillNfeOrOhsObject = (chartType)=>{
    if(!_.isEmpty(chartType)){
        const newChartType = _.cloneDeep(chartType)
        const lengthOfData = newChartType["GREEN"].length

        const arrayOfZeros = createZeroArray(lengthOfData)

        const objectHasNFE = Object.prototype.hasOwnProperty.call(newChartType, "NFE")
        const objectHasOHS = Object.prototype.hasOwnProperty.call(newChartType, "OHS")
        if(!objectHasNFE){
            newChartType["NFE"] = arrayOfZeros
        }
        if(!objectHasOHS){
            newChartType["OHS"] = arrayOfZeros
        }
        return newChartType
    }
}

const runSingleItemFormatter = (value, { seriesIndex, dataPointIndex, w, typeOfValue }) => {
    
    if (seriesIndex === 0) return ""; // Skip placeholder series
                                                    
    const seriesName = w.globals.seriesNames[seriesIndex];
    const greyZoneName = i18n.t("detailsPanel.numericalDetails.bufferZones.grey");
    const greenZoneName = i18n.t("detailsPanel.numericalDetails.bufferZones.green");
    const yellowZoneName = i18n.t("detailsPanel.numericalDetails.bufferZones.yellow");
    const redZoneName = i18n.t("detailsPanel.numericalDetails.bufferZones.red");
    
    let formattedValue = `${typeOfValue}  ${toExcelNumberFormatWithoutDecimals(value)}`;
    
    // If this is the green zone, add green + yellow sum
    if (seriesName === greenZoneName || seriesName === yellowZoneName) {
        const seriesData = w.globals.initialSeries;
        let greenValue = 0;
        let yellowValue = 0;
        let redValue = 0;
        let greyValue = 0;

        for (let i = 1; i < seriesData.length; i++) { // Start from 1 to skip placeholder
            if (seriesData[i].name === greenZoneName && seriesData[i].data && seriesData[i].data[dataPointIndex]) {
                greenValue = seriesData[i].data[dataPointIndex][1] || 0;
            }
            if (seriesData[i].name === yellowZoneName && seriesData[i].data && seriesData[i].data[dataPointIndex]) {
                yellowValue = seriesData[i].data[dataPointIndex][1] || 0;
            }
            if (seriesData[i].name === redZoneName && seriesData[i].data && seriesData[i].data[dataPointIndex]) {
                redValue = seriesData[i].data[dataPointIndex][1] || 0;
            }
            if (seriesData[i].name === greyZoneName && seriesData[i].data && seriesData[i].data[dataPointIndex]) {
                greyValue = seriesData[i].data[dataPointIndex][1] || 0;
            }
        }

        if (seriesName === greenZoneName) {
            const topOfGreen = greenValue + yellowValue + redValue + greyValue;
            const formattedSum = `${typeOfValue}  ${toExcelNumberFormatWithoutDecimals(topOfGreen)}`;
            formattedValue += ` · ${i18n.t("ordersTable.columns.top_of_green")}: ${formattedSum}`;
        }
        if (seriesName === yellowZoneName) {
            const topOfYellow = yellowValue + redValue + greyValue;
            const formattedSum = `${typeOfValue}  ${toExcelNumberFormatWithoutDecimals(topOfYellow)}`;
            formattedValue += ` · ${i18n.t("ordersTable.columns.top_of_yellow")}: ${formattedSum}`;
        }
    }
    
    return formattedValue;
}



export const getGraphOptionsByChart = ( analyticCharts, analyticsChartDataFormatObject, analyticsToggleOptions, activeFromDate, activeToDate)=>{
    const currentAnalyticsChartData = isCurrentChartOneOrChartTwo(analyticCharts, analyticsToggleOptions)
    const { PERCENTAGE, USD } = SYMBOLS
    const allStock = !analyticsToggleOptions[WasPhysicalStockSelected]

    // For single material view with date filters, we need to calculate max Y-axis based on filtered data
    let maxYAxis = 0;
    if (!analyticsToggleOptions[WasAggregateSelected] && activeFromDate && activeToDate) {
        // Filtered chart data has already been processed in AnalyticsSection before passing to Chart component
        // We can just reuse that logic to ensure y-axis matches exactly what's displayed
        const dataToCalculate = _.cloneDeep(currentAnalyticsChartData);
        if (!_.isEmpty(dataToCalculate)) {
            // Apply date filtering to a copy of the data
            const fromTimestamp = new Date(activeFromDate).getTime();
            const toTimestamp = new Date(activeToDate).getTime();
            
            // Filter each series data by date range
            Object.keys(dataToCalculate).forEach(key => {
                if (Array.isArray(dataToCalculate[key])) {
                    dataToCalculate[key] = dataToCalculate[key].filter(point => {
                        const timestamp = point[0];
                        return timestamp >= fromTimestamp && timestamp <= toTimestamp;
                    });
                }
            });
            
            // Calculate max Y axis from the filtered data
            maxYAxis = calculateCustomMaxYAxis(fullFillNfeOrOhsObject(convertToMaxYAxisCalculatorFormat(dataToCalculate)), allStock);
        }
    } else {
        // Use the original calculation for aggregate view
        maxYAxis = Object.keys(currentAnalyticsChartData).length
            ? calculateCustomMaxYAxis(fullFillNfeOrOhsObject(convertToMaxYAxisCalculatorFormat(currentAnalyticsChartData)), allStock)
            : 0;
    }

    const chartOneAllWorkspacesAndAggregateCurrentWorkspace = analyticsToggleOptions[WasAggregateSelected] && analyticsToggleOptions[WasCurrencyUnitsSelected]
    const chartTwoAllWorkspacesAndAggregateCurrentWorkspace = analyticsToggleOptions[WasAggregateSelected] && !analyticsToggleOptions[WasCurrencyUnitsSelected]
                         


    if(!analyticsToggleOptions[WasAggregateSelected]){
        // single-item chart
        const typeOfValue = analyticsToggleOptions[WasCurrencyUnitsSelected] ? USD : " "
        const currentAnalyticsChartData2 = isCurrentChartOneOrChartTwo(analyticsChartDataFormatObject, analyticsToggleOptions)
        
        const currentOptions = {...SINGLE_SKU_CHART_OPTIONS,
                                // the first color is set to white, so that the placeholder series for the fix does not render
                                colors: ['#FFFFFF', ...COMBO_CHART_ORDER_COLORS, '#2ec4b6'],
                                yaxis: {
                                            min:  calculateCustomMinYAxis(currentAnalyticsChartData2),
                                            max:  maxYAxis,
                                            labels: {formatter: (value) => { return toExcelNumberFormatWithoutDecimals(value) }}
                                        },
                                tooltip: {
                                            ...ANALYTICS_CHART_OPTIONS.tooltip,
                                            y: {
                                                formatter: function(value, { seriesIndex, dataPointIndex, w }) {
                                                    return runSingleItemFormatter(value, { seriesIndex, dataPointIndex, w, typeOfValue })
                                                },
                                                title: {
                                                    // prevent displaying the placeholder line "series" in the tooltip
                                                    formatter: (seriesName) => {
                                                        return seriesName === "line" ? "" : seriesName
                                                    },
                                                },
                                            },
                                }
        }

        return currentOptions
    }

    if(chartOneAllWorkspacesAndAggregateCurrentWorkspace){
        const typeOfValue = analyticsToggleOptions[WasCurrencyUnitsSelected] ? USD : " "
        const currentAnalyticsChartData2 = isCurrentChartOneOrChartTwo(analyticsChartDataFormatObject, analyticsToggleOptions)
        const chartOneColors = allStock
            ? CHART_ONE_ORDER_COLORS
            : CHART_ONE_ORDER_COLORS.filter((color) => color !== ANALYTICS_COLOR_CODES.pink)
        const currentOptions = {...SINGLE_SKU_CHART_OPTIONS,
                                colors: [...chartOneColors, "#000000a8"],
                                yaxis: {
                                            min:  calculateCustomMinYAxis(currentAnalyticsChartData2),
                                            max:  maxYAxis,
                                            labels: {formatter: (value) => { return toExcelNumberFormatWithoutDecimals(value) }}
                                        },
                                tooltip: {
                                            ...SINGLE_SKU_CHART_OPTIONS["tooltip"],
                                            y: { 
                                                formatter: function(value){ return `${typeOfValue}  ${toExcelNumberFormatWithoutDecimals(value)}`}
                                            }
                                        }
        }

        return currentOptions
    }

    if(chartTwoAllWorkspacesAndAggregateCurrentWorkspace){
        const currentOptions = {options: ANALYTICS_CHART_OPTIONS,   
            colors: CHART_TWO_ORDER_COLORS,
            yaxis: { min: 0, 
                    max: 100,
                    labels: {formatter: (value) => { return toExcelNumberFormatWithoutDecimals(value) }} 
                },
            tooltip: {
                ...ANALYTICS_CHART_OPTIONS["tooltip"],
                y: { formatter: function(value){return `${toExcelNumberFormatWithoutDecimals(value)} ${PERCENTAGE}`}}
            }
        }
        return currentOptions
    }

}

export const transformComboChartDataWithLineFix = (currentChartData, analyticsToggleOptions) => {
    // Check if chart data is empty or undefined
    if (!currentChartData || !currentChartData.length || !currentChartData[0]) {
        return [];
    }

    const isSingleItemChart = !analyticsToggleOptions[WasAggregateSelected];
    if (!isSingleItemChart) {
        // early return here, because we only need to do the transformation for single items
        return currentChartData;
    }

    let zeroData = [];
    for (let i = 0; i < currentChartData[0].data.length; i++) {
        zeroData.push([currentChartData[0].data[i][0], 0]);
    }

    // Similar to simulation, add the white line as the first item to fix the OHS line
    currentChartData.unshift({
        name: 'line',
        type: 'area',
        data: zeroData,
    });

    return currentChartData;
}

/**
 * Filter chart data series based on from and to date ranges.
 * 
 * @param {Array} chartSeries - The chart series data (array of series objects with name, type, and data)
 * @param {string} fromDate - Start date as YYYY-MM-DD string
 * @param {string} toDate - End date as YYYY-MM-DD string
 * @returns {Array} - Filtered chart series
 */
export const filterChartDataByDateRange = (chartSeries, fromDate, toDate) => {
    if (!chartSeries || !chartSeries.length || !fromDate || !toDate) {
        return chartSeries;
    }

    // Convert date strings to timestamps for comparison
    const fromTimestamp = new Date(fromDate).getTime();
    const toTimestamp = new Date(toDate).setHours(23, 59, 59, 999);
    // Clone the chart series to avoid mutating the original
    const filteredSeries = chartSeries.map(series => {
        // Clone the series object
        const newSeries = { ...series };
        
        // Filter data points where timestamp is between fromDate and toDate
        if (newSeries.data && newSeries.data.length) {
            newSeries.data = newSeries.data.filter(point => {
                const pointTimestamp = point[0]; // The timestamp is at index 0
                return pointTimestamp >= fromTimestamp && pointTimestamp <= toTimestamp;
            });
        }
        
        return newSeries;
    });
    
    return filteredSeries;
}

/**
 * Extracts min and max Y values from filtered chart series data
 * for more accurate Y-axis bounds when filters are applied
 * 
 * @param {Array} filteredSeries - Chart series data already filtered by date range
 * @returns {Object} - Object with min and max values for Y axis
 */
export const getMinMaxFromFilteredSeries = (filteredSeries) => {
    if (!filteredSeries || !filteredSeries.length) {
        return { min: 0, max: 0 };
    }
    
    // Collect all Y values from all series
    let allYValues = [];
    
    filteredSeries.forEach(series => {
        if (series.data && series.data.length) {
            // Skip the placeholder series (index 0) which has name 'line'
            if (series.name !== 'line') {
                const yValues = series.data.map(point => point[1]);
                allYValues = [...allYValues, ...yValues];
            }
        }
    });
    
    if (allYValues.length === 0) {
        return { min: 0, max: 0 };
    }
    
    const min = Math.min(...allYValues);
    const max = Math.max(...allYValues);
    
    // Add small buffer (0.5%) for max value to ensure points aren't cut off
    const maxWithBuffer = max + (max * 0.005);
    
    return { min, max: maxWithBuffer };
}

export const addTotalSeriesToAggregateChart = (chartSeries) => {
    if (!chartSeries || !chartSeries.length) {
        return chartSeries;
    }
    
    // Calculate total for each data point
    const totalData = [];
    const firstSeries = chartSeries[0];
    
    if (firstSeries && firstSeries.data && firstSeries.data.length) {
        for (let i = 0; i < firstSeries.data.length; i++) {
            const timestamp = firstSeries.data[i][0];
            let totalValue = 0;
            
            // Sum all series values at this data point
            chartSeries.forEach(series => {
                if (series.data && series.data[i] && series.data[i][1]) {
                    totalValue += series.data[i][1];
                }
            });
            
            totalData.push([timestamp, totalValue]);
        }
    }
    
    // Add total series as a line (not area) so it appears on top
    const totalSeries = {
        name: i18n.t("statusPanel.onHandStockByZone.total"),
        type: "line",
        data: totalData
    };
    
    return [...chartSeries, totalSeries];
}